export {PAYMENT_PAGE_TYPE} from '@firstpay/contracts/payment_page/constants/payment-page-type';
export {UPI_DEEPLINK_TYPE} from '@firstpay/contracts/crm_backend/constants/upi-deeplink-type';

export enum CLIENT_FIELD_TYPE {
    STRING = 'STRING',
    NUMBER = 'NUMBER',
    REGEX = 'REGEX',
    DATETIME = 'DATETIME',
}

export enum UPI_P2P_KEY {
    UPI_NUMBER = 'upi_number',
    ACCOUNT_NAME = 'account_name',
}
